import { commaFormat } from 'components/features/new-report/utils/formatter';
import React from 'react';
import { useModal } from 'hooks/useModal';
import { useScroll } from 'hooks/useScroll';
import { TargetReturnModal } from '../modal/TargetReturnModal';

type Props = {
  returnPercentage: number;
  registeredAccounts: string[];
  isTargetReturnLimitExcess: boolean;
  targetReturnLimitPercentage: number;
  className?: string;
  goUpdateTarget: () => void;
};

export const TargetReturnInformation = ({
  registeredAccounts,
  returnPercentage,
  isTargetReturnLimitExcess,
  targetReturnLimitPercentage,
  className,
  goUpdateTarget,
}: Props): React.ReactElement => {
  const [isShowModal, { hideModal, showModal }] = useModal();
  // memo: returnPercentageは切上げて画面表示されるため、targetReturnLimitPercentageも併せて切上げ表示する。
  const percentage = (targetReturnLimitPercentage * 10 + 1) / 10;
  useScroll();

  return (
    <>
      <div
        className={`bg-bluegray-60 rounded-lg px-3 pt-3 pb-4 flex flex-col ${className ??
          ''}`}>
        <div className="flex flex-row items-center justify-between">
          <div
            className="flex flex-row items-center cursor-pointer"
            onClick={showModal}>
            <div className="font-bold text-sm text-bluegray-700">
              ターゲットリターン
            </div>
            <div className="icon-help_outline ml-1 text-base text-bluegray-400"></div>
          </div>
          <div className="flex flex-row items-baseline">
            <div
              className={`font-bold text-lg ${
                isTargetReturnLimitExcess ? 'text-red-500' : 'text-bluegray-700'
              }`}>
              {commaFormat(Math.ceil(returnPercentage * 10) / 10, {
                numberOfDecimals: 1,
              })}
            </div>
            <div className="ml-1 text-bluegray-700 text-sm">%</div>
          </div>
        </div>
        <div
          className="grid items-center text-bluegray-700"
          style={{ gridTemplateColumns: 'auto 1fr' }}>
          <div className="mt-1 text-sm">登録口座：</div>
          {registeredAccounts.length !== 0 ? (
            <div className="flex flex-wrap">
              {registeredAccounts.map((account, i) => (
                <div
                  className="border border-bluegray-300 rounded text-xs px-1 ml-1 mt-1"
                  style={{ backgroundColor: '#f3f4f6', color: '#3f3f46' }}
                  key={i}>
                  {account}
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="mt-1 text-sm text-bluegray-700">なし</div>
            </>
          )}
        </div>
      </div>

      {isTargetReturnLimitExcess && (
        <>
          <div className="flex flex-col border p-4 m-4 rounded-lg">
            <div
              className="grid text-red-550"
              style={{ gridTemplateColumns: 'auto 1fr' }}>
              <div className="icon-alert"></div>
              <div className="text-sm font-bold ml-1">
                ターゲットリターンが{percentage}
                ％以上の場合はポートフォリオを提案できません。
              </div>
            </div>
            <button
              className="mt-2 border-bluegray-400 border rounded-lg shadow bg-bluegray-100 flex flex-row items-center justify-center py-2 px-4 text-sm font-bold"
              onClick={goUpdateTarget}>
              目標の設定を見直す
            </button>
          </div>
        </>
      )}

      <TargetReturnModal {...{ isShow: isShowModal, hide: hideModal }} />
    </>
  );
};
